export enum CartInteraction {
  AddToCart = 'addToCart',
  RemoveFromCart = 'removeFromCart',
}

export enum PageType {
  Category = 'category',
  Checkout = 'checkout',
  Purchase = 'purchase',
}

export enum PageName {
  PricingPlans = 'Pricing Plans',
  Addresses = 'Addresses',
  AccountInformation = 'Account Information',
  Billing = 'Billing',
  ReviewOrder = 'Review Order',
  Purchase = 'Purchase',
}

export type CustomerDo = {
  customerEmail: string | null
  customerCountry: string | null
  customerState: string | null
  customerCity: string | null
}

export type OrderDo = {
  orderId: string | null
  orderValue: number | null
  orderValueToPay: number | null
  orderTax: number | null
  orderDiscount: number | null
  orderCoupon: string | null
}

export type ProductDo = {
  productId: string | null
  productName: string | null
  productPrice: number | null
  productCategory: string | null
  productCategory2: string | null
  productCategory3: string | null
  productList: string | null
}

export type UnbdUdo = OrderDo & {
  pageType: PageType
  pageName: PageName
  cartInteraction: CartInteraction | null
  customerDO: CustomerDo | null
  productDO: ProductDo[]
}
